/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["strong.terms[_ngcontent-%COMP%]{font-size:14px}@media (max-width:1024px){.showPassword[_ngcontent-%COMP%]{margin-bottom:-27px}}@media (max-width:640px){.rememberMe[_ngcontent-%COMP%]{width:100%}.forgotEmailAndPassword[_ngcontent-%COMP%]{width:100%;text-align:center;margin-top:1.5rem}}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
